import { useCombinedTableControlsProps } from '@kinetic-ui/shared';

export const useSelectSignalsControls = () => {
  return useCombinedTableControlsProps({
    search: true,
    columnsPreferenceKey: 'SELECT_SIGNALS_ACTION_COLUMNS',
    combinedPreferenceKey: 'SELECT_SIGNALS_ACTION_FILTERS',
  });
};
